const clientPortal = (state = {}, {type, payload}) => {
  switch (type) {
    case 'CLIENT_PORTAL.INIT':
    case 'CLIENT_PORTAL.UPDATE_COMPANIES':
      return {...state, ...payload}
    default:
      return state
  }
}

export default clientPortal
